import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-plus-minus-button',
  template: `
    <div class="w-32 border border-theme-primary rounded-lg items-center flex flex-row bg-theme-surface2-20">
      <div class="mr-auto">
        <app-base-button
          [baseClass]="'rounded-lg px-4 py-3 text-theme-primary text-lg'"
          [disabled]="disabled || (!allowRemove && count <= 1)"
          (onClick)="dec()"
          stateColorScheme="surface">
          <i *ngIf="allowRemove && count<=1" class="fas fa-trash-alt"></i>
          <i *ngIf="!allowRemove || count>1" class="fas fa-minus"></i>
        </app-base-button>
      </div>

      <div class="text-xl font-bold">{{count}}</div>

      <div class="ml-auto">
        <app-base-button
          [baseClass]="'rounded-lg px-4 py-3 text-theme-primary text-lg ' + (remaining != null && remaining <= 0 ? 'opacity-50' : '')"
          [disabled]="remaining != null && remaining <= 0"
          (onClick)="inc()"
          stateColorScheme="surface">
          <i class="fas fa-plus"></i>
        </app-base-button>
      </div>
    </div>
  `
})
export class PlusMinusButtonComponent {
  @Input() disabled: boolean = false;
  @Input() count: number = 1;
  @Input() remaining: number|undefined = undefined;
  @Input() allowRemove: boolean = false;
  @Output() countChange = new EventEmitter<number>();

  dec() {
    this.countChange.emit(this.count - 1);
  }

  inc() {
    this.countChange.emit(this.count + 1);
  }
}
